<template>
<div class="selectOrgBox">
    <div style="width: 100%;height: calc(100% - 40px)" v-loading="loadingData">
      <DomainTreeLockChild ref="orgTree" @getCheckedData="getCheckedData" :showCheckBox="true" @addcheck-treedata="getTreeCheckData" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTreeLockChild>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveData">{{$t('LanguageLib.DETERMINE')}}</el-button>
    </div>
</div>
</template>

<script>
import basicdataApi from '@/api/basicdata'
import DomainTreeLockChild from '@/components/DomainTreeLockChild.vue'
export default {
  name: 'propDialog',
  props: {
  },
  data () {
    return {
      loadingData: false,
      selectDataAddPre: [],
      selectDataAddAllPre: [],
      orgData: [],
      orgTreeData: [],
      oneNodeArr: []
    }
  },
  components: { DomainTreeLockChild },
  created () {
  },
  methods: {
    getCheckedData (checkedData) {
      this.selectDataAddAllPre = checkedData
      this.selectDataAddPre = []
      for (var i in checkedData) {
        this.selectDataAddPre.push(checkedData[i].id)
      }
    },
    // 树组件传过来的数据
    getTreeCheckData (data) {
    },
    // 获取组织树列表
    getTreeData () {
      this.loadingData = true
      // 获取组织树列表
      basicdataApi.gettreelist('get', '/sysdomain/domainTree')
        .then(res => {
          this.orgData = res.data
          this.orgTreeData = this.$commonfun.toTree(res.data, 'childDomainTrees', 'id', 'parentDomainId')
          this.oneNodeArr = this.orgTreeData.length ? [this.orgTreeData[0].id] : []
          this.loadingData = false
          this.disabledArr = []
          for (var i in this.orgData) {
            if (this.selectDataAddPre.indexOf(this.orgData[i].id) >= 0 && this.orgData[i].childDomainTrees) {
              this.getdisabledArr(this.orgData[i].childDomainTrees)
            }
          }
          this.dealTreeOnceChecked(this.orgData)
          this.$nextTick(() => this.$refs.orgTree.setCheckData(this.selectDataAddPre))
        })
        .catch(err => {
          this.loadingData = false
          console.log(err)
        })
    },
    // 数据保存
    saveData () {
      this.$emit('saveSelectOrg', { selectDataIds: this.selectDataAddPre, selectDataObjs: this.selectDataAddAllPre })
    },
    // 渲染选中数据
    renderSelectData ({ selectDataAddPre, selectDataAddAllPre }) {
      this.selectDataAddPre = selectDataAddPre.slice()
      this.selectDataAddAllPre = selectDataAddAllPre.slice()
      this.getTreeData()
      this.$refs.orgTree.setCheckData(selectDataAddPre)
    },

    getdisabledArr (arrMenus) {
      if (arrMenus.length > 0) {
        arrMenus.forEach(item => {
          const arrChildren = item.childDomainTrees
          if (arrChildren) {
            this.getdisabledArr(arrChildren)
          }
          this.disabledArr.push(item.id)
        })
      }
    },
    dealTreeOnceChecked (data) {
      if (data.length > 0) {
        data.forEach(item => {
          const arrChildren = item.childDomainTrees
          if (arrChildren) {
            this.dealTreeOnceChecked(arrChildren)
          }
          if (this.disabledArr.indexOf(item.id) >= 0) {
            this.$set(item, 'disabled', true)
            item.disabled = true
          } else {
            this.$set(item, 'disabled', false)
            item.disabled = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.selectOrgBox {
  height: 430px;
  .left { width: 100% !important; height: 100%; }
  .dialog-footer { padding-top: 10px; text-align: right; }
}
</style>
